import React, { useState, useEffect } from "react";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { GOOGLE_MAPS_API_KEY, MAP_ID } from "../../config";
import { useMapColorScheme } from "../../hooks/useMapColorScheme";

const FixedLocationMap = ({ latitude, longitude }) => {
  const colorScheme = useMapColorScheme();
  const mapOptions = {
    disableDefaultUI: true,
  };

  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);

  useEffect(() => {
    if (latitude && longitude) {
      setLat(parseFloat(latitude));
      setLng(parseFloat(longitude));
    }
  }, [latitude, longitude]);

  if (lat === null || lng === null) {
    return <div>Loading map...</div>;
  }

  return (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
      <div className="rounded-xl overflow-hidden">
        <Map
          key={colorScheme}
          defaultCenter={{ lat: lat, lng: lng }}
          style={{ width: "100%", height: "150px" }}
          mapId={MAP_ID}
          colorScheme={colorScheme}
          options={mapOptions}
          zoom={13}
        >
          <Marker position={{ lat: lat, lng: lng }} />
        </Map>
      </div>
    </APIProvider>
  );
};

export { FixedLocationMap };
